// client/src/seo/GlobalSeo.js

import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function GlobalSeo() {
  const location = useLocation();

  const path =
    location.pathname.replace(/\/+$/, "") || "/";

  const isArticlePage =
    path === "/articles" ||
    path.startsWith("/articles/");

  /*
   * У страниц статей свои SEO-теги находятся
   * в ArticlesPage и ArticlePage.
   */
  if (isArticlePage) {
    return null;
  }

  const isPrivatePage =
    path.startsWith("/course/") ||
    path.startsWith("/student/") ||
    path.startsWith("/tutor/") ||
    path.startsWith("/admin") ||
    path.startsWith("/payment") ||
    path.startsWith("/auth/") ||
    path === "/register" ||
    path === "/reset-password";

  const seoByPath = {
    "/": {
      title: "MeiLin.world — онлайн-платформа китайского языка",
      description:
        "Онлайн-курсы китайского языка для детей, взрослых и путешествий. Видео, аудио и интерактивные задания.",
    },

    "/apps": {
      title:
        "Приложения MeiLin — китайский язык для детей и взрослых",
      description:
        "Приложения MeiLin для изучения китайского языка с нуля: видеоуроки, игры, иероглифы, пиньинь, озвучка и интерактивные задания.",
    },

    "/interactive": {
      title:
        "Интерактивный китайский — игры для изучения слов и иероглифов",
      description:
        "Изучайте китайские слова, фразы, пиньинь и иероглифы через интерактивные игры MeiLin.",
    },
  };

  const seo = seoByPath[path] || {
    title: "MeiLin.world — онлайн-платформа китайского языка",
    description:
      "Онлайн-курсы китайского языка для детей, взрослых и путешествий.",
  };

  const canonical =
    path === "/"
      ? "https://meilin.world/"
      : `https://meilin.world${path}`;

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <link rel="canonical" href={canonical} />

      {isPrivatePage && (
        <meta
          name="robots"
          content="noindex, nofollow"
        />
      )}
    </Helmet>
  );
}